import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import ProfileForm from '@src/features/company/profile/ProfileForm';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function Profile() {
  return (
    <CompanyGuard canRoles={[COMPANY_ROLE.ADMIN, COMPANY_ROLE.USER]}>
      <CompanyDefaultLayout pageName='profile'>
        <CommonHelmet />
        <ProfileForm />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default Profile;
